const roleRank = 'G V M SP AL L ASL SL RP ARP AP P A'.split(' ')

export const rolesByCellType = {
  'O': ['G', 'V', 'M', 'SP', 'AL', 'L'],
  'L': ['G', 'V', 'M', 'SP', 'AL', 'L', 'ASL', 'SL']
}

export const roleFullNames = {
  'A': 'Administrator',
  'AL': 'Associative Leader',
  'ASL': 'Associative Sectional Leader',
  'G': 'Guest',
  'L': 'Leader',
  'M': 'Member',
  'SL': 'Sectional Leader',
  'SP': 'Spiritual Parent',
  'V': 'Visitor',
  'P': 'Pastor'
}

export const cellTypeArray = ['O', 'L']
const cellTypeNameArray = ['Open cell', 'Leaders cell']

export function compareRoleRank (a, b) {
  const av = roleRank.indexOf(a)
  const bv = roleRank.indexOf(b)
  return av > bv ? 1 : av < bv ? -1 : 0
}

export function cellTypesByRole (role) {
  const range = compareRoleRank(role, 'L') > 0 ? 2 : 1
  return cellTypeNameArray.slice(0, range)
}

export function cellTypeName (cell, delta) {
  const level = cell.type === 'O' ? 0 : 1
  return cellTypeNameArray[level + (delta || 0)]
}

export default {
  cellTypeName
}
